import React from 'react';

import { Heading } from '@zillow/constellation-10';

import type { PeopleSection } from '../../../models/index';
import PeopleAndApplicantInformation from './PeopleAndApplicantInformation';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export const MAX_TENANTS = 8;

function TenantInformation_v4({ section, setSection, setSectionValues }: Props) {
  return (
    <>
      <Heading level={3} textStyle="responsive.heading-xs" css={{ marginBottom: 'layout.tighter' }}>
        Tell us about your tenants
      </Heading>
      <PeopleAndApplicantInformation
        isOptional={false}
        maximumPeople={MAX_TENANTS}
        setSectionValues={setSectionValues}
        setSection={setSection}
        section={section}
        initialPeople={0}
      />
    </>
  );
}

TenantInformation_v4.description = `Tenant Information with integration with Applications`;

export default TenantInformation_v4;
